// extracted by mini-css-extract-plugin
module.exports = {"avatar":"W5phxrFDgX5ONiP74aAK"};